import { getPublicMessageFromError } from "./errorHelpers";

export const isPromise = (value: any): value is Promise<any> => {
	if (
		value !== null &&
		typeof value === "object" &&
		typeof value.then === "function" &&
		typeof value.catch === "function"
	)
		return true;
	return false;
};

export class PromisesStackController<ArrItem, ResolvedArrItem> {
	promises: Promise<ResolvedArrItem>[];
	completeLength: number;

	constructor(
		arr: ArrItem[],
		functionToGeneratePromise: (item: ArrItem) => Promise<ResolvedArrItem>,
		onProgress?: (progressStep: number, item: ResolvedArrItem, length: number) => void,
		onComplete?: (resolvedItems: ResolvedArrItem[]) => void
	) {
		this.promises = [];
		this.completeLength = 0;
		for (const item of arr) {
			this.promises.push(
				functionToGeneratePromise(item).then((item) => {
					onProgress?.(++this.completeLength, item, arr.length);
					return item;
				})
			);
		}
		Promise.all(this.promises).then(onComplete);
	}
}
export function getTick() {
	return new Promise<null>((resolve) => resolve(null));
}
export function delay(amount: number) {
	return new Promise((res) => {
		setTimeout(res, amount);
	});
}
export const onNextFrame = (callback?: () => void) => {
	return new Promise((resolve) => {
		requestAnimationFrame(() => {
			requestAnimationFrame(async () => {
				await callback?.();
				resolve(undefined);
			});
		});
	});
};

export const tryAsync = async <T>(
	fn: () => Promise<T>
): Promise<{ ok: true; value: T } | { ok: false; error: string }> => {
	try {
		return { ok: true, value: await fn() };
	} catch (error) {
		return { ok: false, error: getPublicMessageFromError(error) || "Unknown error" };
	}
};
